export const getWidgetConfig = state => state.widgets.config.data;
export const getWidgetConfigFetching = state => state.widgets.config.fetching;
